import { cn } from '@agos/ui'

/**
 * The ring that drains between refreshes.
 *
 * §14.1 makes polling the realtime layer, and this is how the kitchen can tell
 * a quiet night from a frozen screen — without it, a board that stopped
 * fetching looks exactly like a board with nothing on it.
 */

const RADIUS = 13
const CIRCUMFERENCE = 2 * Math.PI * RADIUS
const URGENT_SECONDS = 10

export function CountdownRing({ seconds, total }: { seconds: number; total: number }) {
  const drawn = (seconds / total) * CIRCUMFERENCE
  const urgent = seconds <= URGENT_SECONDS

  return (
    <div className="relative w-8 h-8 flex items-center justify-center flex-shrink-0">
      <svg className="absolute inset-0 -rotate-90" viewBox="0 0 32 32" aria-hidden="true">
        <circle
          cx="16"
          cy="16"
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          className="text-slate-300 dark:text-white/10"
        />
        <circle
          cx="16"
          cy="16"
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray={`${drawn} ${CIRCUMFERENCE}`}
          strokeLinecap="round"
          className={urgent ? 'text-red-700 dark:text-red-400' : 'text-green-700 dark:text-green-400'}
          // Just under a second, so each step finishes before the next begins.
          style={{ transition: 'stroke-dasharray 0.9s linear' }}
        />
      </svg>
      <span
        className={cn('text-[10px] font-bold tabular-nums', urgent ? 'text-red-700 dark:text-red-400' : 'text-slate-700 dark:text-white/70')}
      >
        {seconds}
      </span>
    </div>
  )
}
